export const RECEIVED_INVOICE_MAX_PIC_COUNT = 15;
